import { Link } from 'react-router-dom';
import { featuredAssets } from '@/mocks/homeMocks';

export default function FeaturedAssets() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门精选素材
            </h2>
            <p className="mt-2 text-foreground-600">每周精选高质量素材，助您快速找到所需资源</p>
          </div>
          <Link
            to="/category/game-assets"
            className="hidden md:inline-flex items-center text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredAssets.map((asset) => (
            <Link
              key={asset.id}
              to={`/category/${asset.category}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={asset.image}
                  alt={asset.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {asset.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400">{asset.format}</span>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {asset.title}
                </h3>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-xs text-secondary-500"></i>
                    <span className="text-xs text-foreground-600">{asset.rating}</span>
                  </div>
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <i className="ri-download-line"></i>
                    <span>{asset.downloads.toLocaleString()}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{asset.size}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <Link
            to="/category/game-assets"
            className="inline-flex items-center text-sm text-primary-500 font-medium whitespace-nowrap"
          >
            查看全部素材 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}